(function ($) {
    var $effectItem = $('.effect__item');
    var $boxCounter = $('.box--titel h2');
    var $animateSVG = $('.img--txt--col .image svg');

    if ($effectItem.length) {
        // var itemClass = $effectItem.attr('class').replace(/\hide/g, 'show');

        $effectItem.each(function () {

            var $this = $(this);
            $(window).scroll(function (event) {


                var itemClass = $this.attr('class').replace(/\hide/g, 'show');
                if (isScrolledIntoView($this)) {
                    var timer = 300;
                    setTimeout(function () {
                        $this.attr('class', itemClass);
                    }, timer);
                    timer += 100;
                }
            });
        });
    }

    // Counter vorerst deaktiviert

    // if ($boxCounter.length) {
    //     $(window).scroll(function (event) {
    //         $boxCounter.each(function () {
    //             var $this = $(this),
    //                 countTo = $this.attr('data-count');
    //             if (countTo.length) {
    //                 if (isScrolledIntoView($this)) {
    //                     if (!$this.hasClass('countStart')) {
    //                         $this.text('').addClass('countStart');
    //
    //                         $({countNum: $this.text()}).animate({
    //                                 countNum: countTo
    //                             },
    //                             {
    //                                 duration: 4000,
    //                                 easing: 'linear',
    //                                 step: function () {
    //                                     $this.text(Math.floor(this.countNum));
    //                                 },
    //                                 complete: function () {
    //                                     $this.text(this.countNum);
    //                                 }
    //                             });
    //                     }
    //                 }
    //             }
    //         });
    //     });
    // }


    if ($animateSVG.length) {
        $animateSVG.find('.cls-2').css({'opacity': '0'});
        var timer = 300;
        $(window).scroll(function (event) {
            $animateSVG.each(function () {
                var $this = $(this);
                if (isScrolledIntoView($this)) {

                    $('.cls-3.first').each(function () {
                        var $line = $(this);
                        $line.css({'transform-origin': '100% 100%', 'transition': ' transform 60s'});
                        setTimeout(function () {

                            $line.css({'transform': 'rotate(360deg)'});
                        }, timer);
                        timer += 100;
                    });

                    $animateSVG.find('.cls-2').each(function () {
                        var $dot = $(this);
                        $dot.css({'transition': ' opacity .6s ease'});
                        setTimeout(function () {
                            $dot.css({'opacity': '1'});
                        }, timer);
                        timer += 100;
                    });
                }
            });
        });
    }

    function isScrolledIntoView(elem) {
        var $elem = $(elem);

        var $window = $(window);

        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();

        var elemTop = $elem.offset().top;
        var elemBottom = $elem.offset().top + $elem.height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

})(jQuery);
